module.exports = __webpack_public_path__ + "img/ITA_Airways_Logo.c63b9b8b.svg";